import React, { } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { documentLabelPanelAction } from "../../../context/actions/documentLabelPanelAction";
import "../index.scss";
import TermContactDisclousures from "../TermContactDisclousures"

const CaliforniaPrivacyDisclousures = () => {

    const documentLabelPanelOnState = useSelector(state => state.documentLabelPanelReducer.documentLabelPanelOn);
    const dispatch = useDispatch();

    const documentLabelPanelHandler = () => {
        dispatch(documentLabelPanelAction(!documentLabelPanelOnState))
    }
    const overlayHandler = () => {
        dispatch(documentLabelPanelAction(false))
    }
    return (

        <div className="cookie-notice-page">
            <section className="content-section">
                <div className="content-section-md">
                    <p>
                        At TRAINED, we understand that your privacy is an important part of the trust you place in us. This Notice explains how we collect, use, disclose and otherwise process personal information in connection with our services. Please see section below for further details.
                    </p>
                    <p>
                        These Additional California Privacy Disclosures supplement the information contained in the TRAINED Privacy Notice. These Disclosures apply solely to our processing of personal information of individual residents of the State of California within the scope of the California Consumer Privacy Act of 2018 (CCPA).
                    </p>
                    <p>
                        Unless otherwise expressly stated, all terms in these Disclosures have the same meaning as defined in our <a href="">Privacy Notice</a> as otherwise defined in the CCPA.
                    </p>
                </div>
                <div className="content-section-md">
                    <h2>Learn More About CCPA</h2>
                    <div className="bullet-items">
                        <ul>
                            <li>
                                <a href="#personalInformation">Personal Information Disclosures</a>
                            </li>
                            <li>
                                <a href="#privacyRights">Your Privacy Rights</a>
                            </li>
                            <li>
                                <a href="#submittingRequests">
                                    Submitting Requests
                                </a>
                            </li>
                            <li>
                                <a href="#changesDisclosures">
                                    Changes to These Disclosures
                                </a>
                            </li>
                            <li>
                                <a href="#contactUs">
                                    How to Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="content-section-md content-wrapper">
                    <h2>Additional Notices</h2>
                    <div className="content-section-inner">
                        <h4>TRAINED Cookie Notice</h4>
                        <p>The Cookie Notice supplements the information contained in this Privacy Notice, explaining how we and our business partners and services providers use cookies and related technologies in the course of managing and providing our online services and our communications to you. It explains what these technologies are and why we use them, as well as your rights to control our use of them.</p>
                    </div>
                    <div className="content-section-inner bg-style-1">
                        <h4>Who We Are</h4>
                        <p>
                            <strong>TRAINED:</strong> TRAINED is an integrated technology solutions provider primarily serving business and governmental entities. TRAINED is headquartered in the United States. When we use the terms “TRAINED”, “we”, “us”, or “our” in this Notice, we are referring to TRAINED and its subsidiaries and affiliated companies worldwide.
                        </p>
                    </div>
                    <div className="content-section-inner">
                        <h4>Services Covered By This Notice</h4>
                        <p>
                            <strong>Our Services:</strong> When we use the term “services”, we are referring to all the services that we offer on our own behalf, including our product offerings and the websites and mobile applications that post or link to this Notice.  We are not referring to services that we provide solely on behalf of a third party, such as outsourced IT services we may provide to another company. Please refer to the privacy notice of the third party with which you have a relationship for information on how they engage service providers, like us, to process personal information on their behalf.
                        </p>
                    </div>
                </div>
            </section>
            <section className="content-section" id="personalInformation">
                <h2>What is Personal Information?</h2>
                <p>
                    When we use the term “personal information” in this Notice, we mean information that identifies, relates to, describes, is reasonably capable of being associated with, or could reasonably be linked, directly or indirectly, to you. It does not include aggregated or deidentified information that is maintained in a form that is not capable of being associated with or reasonably linked to you.
                </p>
            </section>
            <section className="content-section">
                <h2>Collection, Disclosure and Sale of Personal Information</h2>
                <p>
                    In the last 12 months, we have collected the following categories of personal information:
                </p>
                <div className="bullet-items">
                    <ul>
                        <li>
                            <strong>Identifiers</strong>, such as name, account ID, customer ID, and username/password.
                        </li>
                        <li>
                            <strong>California Customer Records</strong> (Cal. Civ. Code § 1798.80(e)), such as mailing address, phone number, and payment information.
                        </li>
                        <li>
                            <strong>Commercial Information</strong>, such as order details, order/product preferences, credit information, and investment information.
                        </li>
                        <li>
                            <strong>Internet/Network Information</strong>, such as log file data (e.g., IP address, browser type, clickstream data) and cookies and related technology data (e.g., your usage and activity on our online services).
                        </li>
                        <li>
                            <strong>Geolocation Data</strong>, such as your general geographic location based on your IP address or more precise location when accessing our online services through a mobile device.
                        </li>
                        <li>
                            <strong>Sensory Information</strong>, such as voice recordings from calls.
                        </li>
                        <li>
                            <strong>Profession/Employment Information</strong>, such as your job title, department, employer or business, and, if you perform work on our behalf.
                        </li>
                        <li>
                            <strong>Other Personal Information</strong>, such as your attendance at an event, your responses to survey questions about your business and your satisfaction with TRAINED, your statements and submissions for entry in a contest, social media account information in accordance with your settings on the social media site, user-generated content (to the extent that it is personal information) and the contents of your email, text or chat with us.
                        </li>
                    </ul>
                    <p>
                        We disclose all the categories of personal information described above for our business purposes. We do not “sell” personal information as most people would typically understand that term. However, as is common practice among companies that operate online, we do allow certain third-party partners and providers to collect information about consumers directly through our services for purposes of analyzing and optimizing our services, measuring statistics and the success of ad campaigns, and detecting and reporting fraud. To the extent this practice is interpreted to constitute a “sale” of personal information under the CCPA, please refer to our Cookie Notice for more information, including how to exercise your rights to opt-out of cookies, analytics and personalized advertising.
                    </p>
                </div>
            </section>
            <section className="content-section" id="privacyRights">
                <h2>Your Privacy Rights</h2>
                <p>
                    As a California resident, you may be able to exercise the following rights in relation to the personal information about you that we have collected (subject to certain limitations at law):
                </p>
                <div className="content-section-md">
                    <h2>Access</h2>
                    <p>The right to access and obtain a copy of the specific pieces of personal information we have collected about you in the last 12 months. </p>
                </div>
                <div className="content-section-md">
                    <h2>Opt Out</h2>
                    <p>The right to direct us not to sell personal information we have collected about you to third parties. </p>
                </div>
                <div className="content-section-md">
                    <h2>Deletion</h2>
                    <p>The right to request the deletion of personal information we have collected from you, subject to certain exceptions. </p>
                </div>
                <div className="content-section-md">
                    <h2>Knowledge</h2>
                    <p>The right to request the following information relating to the personal information we have collected about you or disclosed in the last 12 months, upon verification of your identity:</p>
                    <ul className="bullet-items">
                        <li>
                            The categories of personal information we have collected about you;
                        </li>
                        <li>
                            The categories of sources of the personal information we have collected about you;
                        </li>
                        <li>
                            The categories of personal information we have disclosed about you to third parties for a business purpose, and the categories of recipients to whom this information was disclosed;
                        </li>
                        <li>
                            The categories of personal information we have sold about you (if any), and the categories of third parties to whom this information was sold; and
                        </li>
                        <li>
                            The business or commercial purposes for collecting or, if applicable, selling personal information about you.
                        </li>
                    </ul>
                </div>
                <div className="content-section-md">
                    <h2>Non-Discrimination</h2>
                    <p>The right not to receive discriminatory treatment for exercising any of the rights described above.  However, please note that if the exercise of the rights described above limits our ability to process personal information (such as in the case of a deletion request), we may no longer be able to provide you our products or services or engage with you in the same manner. </p>
                </div>
            </section>
            <section className="content-section" id="submittingRequests">
                <h2>Submitting Requests</h2>
                <section className="content-section-md">
                    <p>
                        <strong>
                            To Exercise Your Right to Access, Knowledge or Deletion
                        </strong>
                    </p>
                    <p>
                        To submit a request to exercise your right to access, knowledge or deletion, please contact us as set forth in the <a href="#contactUs">How to Contact Us</a>  section below, by calling 833.888.0103, or sending an email requesting to exercise your right to additional information under California's "Shine the Light" law, please indicate in the request you would like to exercise your right under the "Shine the Light" law.
                    </p>
                    <p>
                        We will need to verify your identity before processing your request. In order to verify your identity, we will generally either require the successful authentication of your account or the matching of sufficient information you provide us to the information we maintain about you in our systems. This process may require us to request additional personal information from you.
                    </p>
                    <p>
                        In certain circumstances, we may decline a request to exercise the right to access, knowledge or deletion, particularly where we are unable to verify your identity.
                    </p>
                </section>
                <section className="content-section-md">
                    <p>
                        <strong>
                            To Exercise Your Right to Opt Out of Personal Information Sales
                        </strong>
                    </p>
                    <p>
                        As noted above, we do not "sell" personal information as most people would typically understand that term. However, we do allow certain third-party partners and providers to collect information about consumers directly through our services for purposes of analyzing and optimizing our services and ads, providing content and ads that are more relevant, measuring statistics and the success of ad campaigns, and detecting and reporting fraud. To the extent this practice is interpreted to constitute a "sale" under the CCPA, please see our
                        <a href=""> Cookie Notice</a> for more information, including how to exercise your rights to opt-out of cookies, analytics, and personalized advertising.
                    </p>
                </section>
            </section>
            <section className="content-section" id="changesDisclosures">
                <h2>Changes to These Disclosures</h2>
                <p>
                    We may update these Disclosures from time to time. When we make changes to these Disclosures, we will change the date at the end of these Disclosures to include the "Last Updated" date. If we make material changes to these Disclosures, we will notify you by email to your registered email address, by prominent posting on our services, or through other appropriate communication channels. All changes shall be effective from the date of publication unless otherwise provided in the notification.
                </p>
            </section>
            <TermContactDisclousures id="contactUs" />
        </div>




    )
};
export default CaliforniaPrivacyDisclousures;